<template>
    <div>
        <vs-row class="mt-2">
            <vs-col w="12">
                <vs-button
                    v-if="users != '' && permisos.includes('ver-conciliar-info-extra')"
                    color="#55ce63"
                    relief
                    :loading="loadingExcel"
                    @click="getExcel()"
                    class="ml-auto"
                >
                    <i class="fas fa-download mr-2"></i> Descargar reporte
                </vs-button>

                <vs-alert v-if="alerta === 'mostrar'">
                    <template #title>
                        No hay información
                    </template>
                    Prueba colocando otra fecha
                </vs-alert>
            </vs-col>
        </vs-row>
        <div style="max-width: 100%;">
            <vs-table striped clas="table-responsive" 
                v-dragscroll="{ target: '.vs-table', active: true }">
                <template #thead>
                <vs-tr>
                    <!-- <vs-th style="width: 50px !important; ">
                        <vs-checkbox
                            :indeterminate="selected.length == users.length" v-model="allCheck"
                            @change="selected = $vs.checkAll(selected, users)"
                        />
                    </vs-th> -->
                    <vs-th style="width: 30%;">
                        Alumno
                    </vs-th>
                    <vs-th style="width: 45%;">
                        Referencia
                    </vs-th>
                    <vs-th style="width: 25%;">
                        Información de pago
                    </vs-th>
                </vs-tr>
                </template>
                <template #tbody style="vertical-align: top">
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in users"
                    :data="tr"
                    style="vertical-align: top"
                >
                    <!-- <vs-td checkbox>
                        <vs-checkbox :val="tr" v-model="selected" />
                    </vs-td> -->
                    <vs-td>
                        <div class="d-flex">
                            <div>
                                <vs-avatar circle>
                                    <img :src="'/api/personas/' + tr.persona_id + '/avatar'" @error="setAltImg" alt="">
                                </vs-avatar>
                            </div>
                            <div class="ml-2">
                                <strong>{{ tr.nombre }}</strong><br>
                                <span style="text-transform: uppercase; font-size: 11px;">Matrícula</span>
                                <strong>{{ tr.matricula }}</strong>
                                <!-- <div style="width: 30%;">
                                    <vs-tooltip class="m-auto">
                                        <vs-button
                                            success
                                            flat
                                            :href="`/estado-de-cuenta/${tr.persona_id}/gestion`"
                                            blank
                                        >
                                            <i class="fas fa-external-link-alt"></i>
                                        </vs-button>
                                        <template #tooltip>
                                            Ir a Gestión de finanzas
                                        </template>
                                    </vs-tooltip>
                                </div> -->
                            </div>
                        </div>
                    </vs-td>
                    <vs-td colspan="2">
                        <table>
                            <tr v-for="(info, i) in tr.info" :key="i" :style="tr.info.length > 1 ? 'border-bottom: 1px solid #DFDFDF' : 'border-bottom: none'">
                                <td style="width: 70%">
                                    <div class="d-block">
                                        <div v-if="info.autorizacion">
                                            <p class="mb-0"><small>AUTORIZACIÓN</small></p>
                                            <p><strong>{{ info.autorizacion }}</strong></p>
                                        </div>

                                        <div v-if="info.referencia">
                                            <p class="mb-0"><small>REFERENCIA</small></p>
                                            <p><strong>{{ info.referencia }}</strong></p>
                                        </div>

                                        <div v-if="info.fecha_pago">
                                            <p class="mb-0"><small>FECHA</small></p>
                                            <p><strong>{{ info.fecha_pago }}</strong></p>
                                        </div>
                                        
                                        <!-- <vs-button
                                            primary
                                            relief
                                            v-if="info.status == 'no conciliado'"
                                            @click="activeSantander=!activeSantander; selectedRow = tr; selectInfo = info"
                                        >
                                            <i class="fas fa-check mr-2"></i> Conciliar pago
                                        </vs-button> -->
                                    </div>
                                </td>
                                <td style="width: 30%">
                                    <div class="d-block">
                                        <div v-if="info.monto_total">
                                            <p class="mb-0"><small>MONTO</small></p>
                                            <p><strong>{{ info.monto_total }}</strong></p>
                                        </div>
                                        
                                        <p class="mb-0"><small>TIPO DE PAGO</small></p>
                                        <md-chip class="mb-1 fontMedium mini-chip" :class="getColorMetodo(info)"><strong> {{ info.tipo_pago != '' ? info.tipo_pago : 'Sin especificar' }} </strong></md-chip>

                                        <div v-if="info.status">
                                            <p class="mb-0"><small>ESTATUS</small></p>
                                            <p class="text-capitalize"><strong>{{ info.status }}</strong></p>
                                        </div>
                                    </div>
                                </td>
                            </tr> 
                        </table>
                    </vs-td>
                </vs-tr>
                </template>
                
                <template #footer>
                    <vs-pagination  v-model="page" :length="pages" />           
                </template>
                <template #notFound>
                    No hay registros
                </template>
            </vs-table>
        </div>
        <modal-santander v-model="activeSantander" :row="selectedRow" :info="selectInfo" @refreshTable="getInfoConciliacion"></modal-santander>
    </div>
</template>

<script>
import ModalSantander from './modal/conciliar-santander.vue'
export default {
    props: [
        'users',
        'permisos',
        'alerta',
        'totalAlumnos',
        'archivos',
        'users',
        'institucion'
    ],
    data(){
        return {
            selectedRow: [],
            selectInfo: [],
            activeSantander : false,
            page: 1, 
            max: 10,
            pages: 0,
            search: '',
            active: 0,
            selected: [],
            allCheck: false,
            statusColores: {
                "Facturado" : "green",
                "No facturado": "red"
            },
            colorFactura: {
                "Efectivo": "green",
                "Cheque nominativo": "yellow",
                "Transferencia electrónica de fondos": "blue",
                "Tarjeta de crédito" : "red",
                "Monedero electrónico": 'purple',
                "Dinero electrónico": "gray",
                "Vales de despensa": "pink",
                "Dación en pago": "brown",
                "Pago por subrogación": "green",
                "Pago por consignación": "yellow",
                "Condonación" : "blue",
                "Compensación" : "red",
                "Novación": 'purple',
                "Confusión": "gray",
                "Remisión de deuda": "pink",
                "Prescripción o caducidad": "brown",
                "A satisfacción del acreedor": "green",
                "Tarjeta de débito": "yellow",
                "Tarjeta de servicios" : "blue",
                "Aplicación de anticipos" : "red",
                "Intermediario Pagos": 'purple',
                "Por definir": "gray"
            },
        }
    },
    components:{
        ModalSantander
    },
    methods:{
        getInfoConciliacion(){

      		this.$emit('refreshTable',true)
        },
        async getDownArchivo(ruta, nombreFile){
            var optionAxios = {
                headers: {
                    'Access-Control-Allow-Origin':'*'
                }
            }
            axios({
                  url: ruta,
                  method: 'GET',
                  responseType: 'blob',
                  headers: {
                        "Access-Control-Allow-Origin": "*",
                    }
              }).then((response) => {
                   var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                   var fileLink = document.createElement('a');

                   fileLink.href = fileURL;
                   fileLink.setAttribute('download', nombreFile);
                   document.body.appendChild(fileLink);

                   fileLink.click();
              });
            this.$vs.notification({
                progress: 'auto',
                color: 'success',
                position: 'bottom-right',
                title: 'Éxito',
                text: 'Descarga lista'
            })

            
        },
        getColorMetodo(status){
            if (status.tipo_pago === 'Efectivo'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Cheque nominativo'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Transferencia electrónica de fondos'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Tarjeta de crédito'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Monedero electrónico'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Dinero electrónico'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Vales de despensa'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Dación en pago'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Pago por subrogación'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Pago por consignación'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Condonación'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Compensación'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Confusión'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Novación'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Remisión de deuda'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Prescripción o caducidad'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'A satisfacción del acreedor'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Tarjeta de débito'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Tarjeta de servicios'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Aplicación de anticipos'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Intermediario Pagos'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }else if (status.tipo_pago === 'Por definir'){
                return `col-${this.colorFactura[status.tipo_pago]}`
            }
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
    }
}
</script>
<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
<style scoped>
    .btn:focus{
        box-shadow: none !important;
    }
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .vs-avatar img{
        object-fit:contain;
    }

</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>